import baseReport from '../baseReport';
import Meses from '@/utils/dias';
import formatDataBR from '@/plugins/filters/formatDataBR';

const montarTableHeader = (data, periodos) => {
  let periodoAnterior = '';
  return [
    [
      {
        text: 'Alunos',
        alignment: 'center',
        margin: [0, 7, 0, 0],
        rowSpan: 2,
        style: 'tableHeader',
      },
      ...data.map((key) => {
        if (key.mes !== periodoAnterior) {
          periodoAnterior = key.cdpravadi;
          return {
            text: periodos.find(n => n.value === key.cdpravadi).text,
            alignment: 'center',
            colSpan: data.filter(n => n.cdpravadi === key.cdpravadi).length,
            bold: true,
            style: 'tableHeader',
          };
        }
        return {};
      }),
      {
        text: 'Total',
        alignment: 'center',
        margin: [0, 7, 0, 0],
        rowSpan: 2,
        style: 'tableHeader',
      },
    ],
    [
      '',
      ...data.map(key => ({ text: Meses.mesesMin[key.mes - 1], alignment: 'center', style: 'tableHeader' })),
      {},
    ],
  ];
};

const montarAssinatura = (professores, filtros, tipoDeEnsino) => {
  return [
    {
      columns: [
        { width: '*', text: '' },
        {
          width: 'auto',
          alignment: 'right',
          layout: 'noBorders',
          table: {
            body: [
                ...professores.map(key => ([{
                  alignment: 'center',
                  fontSize: 8,
                  margin: [15, 35, 15, 0],
                  text: [
                    '_____________________________________________\n',
                    'Assinatura do Professor/Educador\n',
                    `${key.nmfuncion}\n`,
                    `${key.cdpessoal}-${key.cdmatric}`
                  ],
                }])),
            ],
          },
        },
        { width: '*', text: '' },
      ],
    },
    {
      fontSize: 9,
      italics: true,
      margin: [0, 20, 0, 0],
      text: [{ text: 'Obs.: ', bold: true }, (filtros.aaletivo >= 2020 && tipoDeEnsino === 'I') ? 'Este relatório apresenta todas as aulas cadastradas correspondentes a campos de experiência.' : 'Este relatório apresenta todas as aulas cadastradas correspondentes a disciplina.'],
    },
  ];
};

const registroFrequenciaAnalitico = async ({ date, time, filtros, data, professores, periodos, tipoDeEnsino, indicaanoletivoexcedeu = 'N', anoSubsequente }) => {
  const headerFooter = await baseReport({ date, time, title: 'Diário de Classe', subTitle: 'Registro de Frequência Consolidado' });

  let nameProfessores = professores.reduce((total, key) => `${total}${key.nmfuncion.trim()}, `, '');
  nameProfessores = nameProfessores.substring(0, nameProfessores.length - 2);

  const AnoSubsquente = indicaanoletivoexcedeu === 'S' ? [ { text: '   Ano subsequente:   ', bold: true }, anoSubsequente ] :  []

  const filtrosFormated = [
    {
      text: filtros.nmescola,
      bold: true,
      fontSize: 12,
      alignment: 'center',
      margin: [0, 5, 0, 5],
    },
    {
      fontSize: 9,
      text: [
        { text: 'Professor/Educador:   ', bold: true },
        nameProfessores,
      ],
    },
    {
      fontSize: 9,
      columns: [
        {
          text: [
            { text: 'Ano letivo:   ', bold: true },
            filtros.aaletivo,
            ...AnoSubsquente
          ],
        },
        {
          alignment: 'right',
          text: [
            { text: 'Turma:   ', bold: true },
            filtros.turma,
          ],
        },
      ],
    },
    {
      fontSize: 9,
      columns: [
        {
          text: [
            { text: (filtros.aaletivo >=2020 && tipoDeEnsino === 'I') ? 'Campos de Experiência:   ' : 'Disciplina:   ', bold: true },
            filtros.disciplina,
          ],
        },
      ],
    },
  ];

  if (data.length <= 0 || (data.length > 0 && data[0].faltas.length <= 0)) {
    return {
      ...headerFooter,
      content: [{
        text: 'Nenhuma frequência encontrada.',
        fontSize: 10,
        alignment: 'center',
        margin: [0, 15, 0, 0],
        bold: true,
      }],
    };
  }

  let faltas = [];
  const frequencia = data.map((key) => {
    let total = 0;
    faltas = key.faltas.map((falta) => {
      // eslint-disable-next-line radix
      total += parseInt(falta.qnt);
      return { text: ((falta.qnt > 0) ? falta.qnt : ''), alignment: 'center' };
    });
    return [
     // key.nmaluno,
    // `${key.nmaluno}${(key.situacao_fim)? ` - ${key.situacao_fim.dssitalun}` : ''}`,
     `${key.nmaluno}\n Dt Enturmação: ${formatDataBR(key.dtsitalun)}${(key.situacao_fim)? ` - ${key.situacao_fim.dssitalun}` : ''}` +
     `${(key.dtafastam)? ` - ${formatDataBR(key.dtafastam)}` : ''}`,

      ...faltas,
      { text: total, alignment: 'center' },
    ];
  });

  const dataFormated = [
    {
      margin: [0, 10, 0, 0],
      fontSize: 7,
      table: {
        widths: [
          { width: '*' },
          ...faltas.map(() => ({ width: 'auto' })),
          { width: 'auto' },
        ],
        body: [
          ...montarTableHeader(data[0].faltas, periodos, indicaanoletivoexcedeu),
          ...frequencia,
        ],
      },
    },
  ];

  return {
    ...headerFooter,
    content: [
      ...filtrosFormated,
      ...dataFormated,
      ...montarAssinatura(professores, filtros, tipoDeEnsino),
    ],
    styles: {
      tableHeader: {
        bold: true,
        fontSize: 10,
        color: 'black',
        fillColor: '#eeeeee',
      },
    },
  };
};

export default registroFrequenciaAnalitico;
